import "./Testimonials.scss";
import { TitleSecondary } from "..";

export const Testimonials = (props) => {
    return (
      <div id='testimonials'>
        <div className='testimonials-container'>
          <div className='section-title text-center'>
            <TitleSecondary>Nuestros clientes</TitleSecondary>
          </div>
          <div className='section-testimonials'>
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className='col-md-4'>
                    <div className='testimonial'>
                      <div className='testimonial-image'>
                        {' '}
                        <img src={d.img} alt='' />{' '}
                      </div>
                      <div className='testimonial-content'>
                        <p>"{d.text}"</p>
                        <div className='testimonial-meta'> - {d.name} </div>
                      </div>
                    </div>
                  </div>
                ))
              : 'loading'}
          </div>
        </div>
      </div>
    )
  }